<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
						<div class="modal-container" @click.stop>

							<div class="modal-header row" style="justify-content: flex-end;">
								<!-- <div class="col-6">
								<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
								</div> -->
								<div class="col">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
								</div>
							</div>

							<div class="modal-body" style="min-height:75vh">
								<h2 class="title">Kirim Kwitansi</h2>

								<div class="row row-space" v-if="backdate">
									<div class="col-12 input-group">
										<label class="label">Tanggal Pengiriman Kwitansi</label>
										<!-- <input type="text" class="input--style-4" v-model="no_resi" placeholder="Ketik Nomor Resi"/> -->
										<Datepicker input-class="input--style-4" class="w-100" type="text" name="policy_expiry" v-model="date" placeholder="Tanggal Pengiriman Kwitansi"/>
									</div>
									
								</div>
									
								<div class="row row-space">
									<div class="col-12 input-group">
									<label class="label">Foto Bukti Kwitansi</label>
									<!-- <input type="text" class="input--style-4" v-model="no_resi" placeholder="Ketik Nomor Resi"/> -->
									<input  type="file" name="myImage" accept="image/*"  class="input--style-4" @change="validateSize"/>
									</div>
								</div>

								

								<div class="row mb-3">
									<div class="col-12 text-center">
										<button class="btn btn-danger mr-3" style="width: 100px;" @click="$emit('closeModal')">Kembali</button>
										<button class="btn btn-primary " style="width: 100px;" @click="submitPostage()">Kirim</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import env from '@/env'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
	components : {
		Datepicker
	},
	data () {
		return {
			file : null,
			backdate : true,
			date : null,
		}
	},
	props : ['form_code'],
	mounted () {
		// this.backdate = parseInt(this.form_code.slice(1, 3)) < 7 ? true : false
	},
	methods : {
    	validateSize : function(data){
			
            var file = data.target.files[0];

          
			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				// this.fileError = "Limit Size Gambar 8 MB";
				this.$store.dispatch('triggerAlert' , [false , 'Limit Size Gambar 4 MB'])
				return false;
			}

			this.file =  file ;

            return true;
            
		},
        async uploadAllImage() {
			try {
				// let image = null
				let url = env.urlStart + "/api/v1/workorder/image"
				let formData = new FormData()

				formData.append('work_order' , this.file)
				
				let response  = await this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
				console.log(response)
				return response.data.data.filename
			}
			catch(err) {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Ada terjadi kendala saat proses upload gambar. Mohon dicoba beberapa saat lagi.'])
			}
        },
		async submitPostage () {
			if(!this.file) {
				this.$store.dispatch('triggerAlert' , [false ,'Foto Bukti Kirim Kwitansi Harus Di-isi!'])
				return
			}

			let data = {  
				"logType" : 7,
				value : await this.uploadAllImage()
			}

			if(this.backdate) data.created_at = new moment(this.date).format('YYYY-MM-DD') + ' 00:00:00'
			
			this.$http.post('/api/v1/workorder/log/' + this.form_code , data)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Penawaran Work Order Selesai.'])
				this.$emit('closeModal')
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Ada Terjadi Kendala. Mohon dicoba beberapa saat lagi.'])
			})
		}
	}
}
</script>

<style scoped>
p {
  font-size: 15px;
}

td {
  font-size: 12px;
}

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


.companyDetails{
  margin-bottom: 5px;
  font-size:.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle{
  margin-top:8px;
  font-size:14px;
  font-weight: 700;
}
.contentVariable{
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
}

</style>